module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "id": "pg_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The major advances in civilization are processes that all but wreck the societies in which they occur.… It is the business of the future to be dangerous; and it is among the merits of science that it equips the future for its duties.")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—Alfred North Whitehead")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("The brain is wider than the sky")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("For, put them side by side")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("The one the other will contain")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-verse-fmepiv"
  }, [_vm._v("With ease, and you beside.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—Emily Dickinson")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0